import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, Activity, BarChart3, FileText, User } from "lucide-react";

const ITEMS = [
  { to: "/investor", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/investor/positions", label: "Positions", icon: Activity },
  { to: "/investor/trades", label: "Trades", icon: BarChart3 },
  { to: "/investor/reports", label: "Reports", icon: FileText },
];

// Fixed mobile bottom navigation — investor only. 4 primary tabs + a "Profile"
// button that opens the existing side drawer (Trades, MT5, Notifications, Withdrawals, Sign Out).
export default function InvestorBottomNav({ onMore }) {
  // Flag the body so global CSS can lift the floating WhatsApp launcher above the nav (mobile only).
  useEffect(() => {
    document.body.classList.add("has-bottom-nav");
    return () => document.body.classList.remove("has-bottom-nav");
  }, []);
  return (
    <nav
      data-testid="investor-bottom-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0a0a0a]/95 backdrop-blur-xl border-t border-white/10"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex items-stretch justify-around px-1">
        {ITEMS.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.end}
            data-testid={`bottomnav-${it.label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex-1 relative flex flex-col items-center justify-center gap-1 py-2.5 min-h-[56px] transition-colors ${
                isActive ? "text-[#00F0FF]" : "text-gray-500 hover:text-gray-300"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className={`flex items-center justify-center transition-all ${isActive ? "drop-shadow-[0_0_8px_rgba(0,240,255,0.5)]" : ""}`}>
                  <it.icon size={20} strokeWidth={isActive ? 2.2 : 1.7} />
                </span>
                <span className="text-[10px] font-medium tracking-wide">{it.label}</span>
                {isActive && <span className="absolute top-0 h-0.5 w-8 rounded-full bg-gradient-to-r from-[#7000FF] to-[#00F0FF]" />}
              </>
            )}
          </NavLink>
        ))}
        <button
          type="button"
          onClick={onMore}
          data-testid="bottomnav-profile"
          className="flex-1 flex flex-col items-center justify-center gap-1 py-2.5 min-h-[56px] text-gray-500 hover:text-gray-300 transition-colors"
        >
          <User size={20} strokeWidth={1.7} />
          <span className="text-[10px] font-medium tracking-wide">Profile</span>
        </button>
      </div>
    </nav>
  );
}
